<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRelatorioRastreabilidade',
    componentOptions: {
        title: 'relatorioRastreabilidade',
        actions: [
            [
                {
                    name: 'Relatório de rastreabilidade',
                    iconClass: 'lyra-icon relatorio-rastreabilidade',
                    showView: false,
                    action: 'abrir',
                    route: 'RelatorioRastreabilidade',
                    nameTranslationKey:
                        'mensagens.menuLateral.relatorioRastreabilidade'
                }
            ]
        ]
    },

    methods: {
        abrirGestaoRelatorioRastreabilidade() {
            if (this.$route.name !== 'RelatorioRastreabilidade') {
                this.$router.push({ name: 'RelatorioRastreabilidade' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
